import { useState } from "react";

const Heart = () => {
  const [liked, setLiked] = useState(false);

  const toggle = () => setLiked(!liked);

  return (
    liked ?
      <i onClick={toggle} className="fas fa-heart text-red-500"></i> :
      <i onClick={toggle} className="far fa-heart"></i>
  );
}

export default Heart;